import { ref } from "vue";

export const focusElement = (element: HTMLElement, selector?: string): void => {
	const elementRef = ref<NodeList>();

	if(selector) {
		elementRef.value = (element as any).$el.querySelectorAll(selector);
	}
	else {
		elementRef.value = (element as any).$el.querySelectorAll("input");
	}
            
	if(elementRef.value) {
		(elementRef.value[0] as any).select();
	}    
}